const macosVersionToName = new Map([
  [`27`, `Golden Gate`],
  [`26`, `Tahoe`],
  [`15`, `Sequoia`],
  [`14`, `Sonoma`],
  [`13`, `Ventura`],
  [`12`, `Monterey`],
  [`11`, `Big Sur`],
  [`10.15`, `Catalina`],
  [`10.14`, `Mojave`],
  [`10.13`, `High Sierra`],
  [`10.12`, `Sierra`],
  [`10.11`, `El Capitan`],
  [`10.10`, `Yosemite`],
  [`10.9`, `Mavericks`],
  [`10.8`, `Mountain Lion`],
  [`10.7`, `Lion`],
  [`10.6`, `Snow Leopard`],
  [`10.5`, `Leopard`],
  [`10.4`, `Tiger`],
  [`10.3`, `Panther`],
  [`10.2`, `Jaguar`],
  [`10.1`, `Puma`],
])

const windowsNTToName = new Map([
  [`10.0`, `10`],
  [`6.3`, `8.1`],
  [`6.2`, `8`],
  [`6.1`, `7`],
  [`6.0`, `Vista`],
  [`5.2`, `Server 2003`],
  [`5.1`, `XP`],
  [`5.0`, `2000`],
])

export function osName() {
  const ua = navigator.userAgent

  const macMatch = ua.match(/Mac OS X (\d+[._]\d+(?:[._]\d+)?)/)
  if (macMatch) {
    const version = macMatch[1].replace(/_/g, `.`)
    const parts = version.split(`.`)
    const majorInt = parseInt(parts[0], 10)
    const key = majorInt === 10 ? `10.${parts[1]}` : parts[0]
    const prefix = majorInt >= 11 ? `macOS` : `OS X`
    const name = macosVersionToName.get(key)
    return prefix + (name ? ` ${name}` : ``)
  }

  const winMatch = ua.match(/Windows NT (\d+\.\d+)/)
  if (winMatch) {
    const name = windowsNTToName.get(winMatch[1])
    return `Windows` + (name ? ` ${name}` : ``)
  }

  const androidMatch = ua.match(/Android (\d+(?:\.\d+)?)/)
  if (androidMatch) {
    return `Android ${androidMatch[1]}`
  }

  const iosMatch = ua.match(/(?:iPhone|iPad|iPod) OS (\d+[._]\d+)/)
  if (iosMatch) {
    return `iOS ${iosMatch[1].replace(`_`, `.`)}`
  }

  if (/Linux/.test(ua)) {
    return `Linux`
  }

  return null
}
